/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag jsx
 */

import { useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import { cssMap, jsx } from '@atlaskit/css';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import { Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import type { InlineChatError } from '../../../../controllers/inline-chat-controller';

import messages from './messages';

const styles = cssMap({
	message: {
		color: token('color.text'),
	},
});

type ErrorViewProps = {
	error: InlineChatError | null;
	onClose: () => void;
	onSecondaryAction?: () => void;
};

export const ErrorView = ({ error, onClose, onSecondaryAction }: ErrorViewProps) => {
	const { formatMessage } = useIntl();

	return (
		<Inline spread="space-between" alignBlock="center">
			<Inline space="space.100" alignBlock="center" xcss={styles.message}>
				<StatusErrorIcon
					color={token('color.icon.danger')}
					spacing="spacious"
					size="medium"
					label=""
				/>
				{/* TODO: replace with pre-set error messages with i18n based on the error that arises */}
				{error && error.content}
			</Inline>
			<Inline space="space.100">
				<Button appearance="subtle" onClick={onClose}>
					{formatMessage(messages.closeButtonLabel)}
				</Button>
				{onSecondaryAction && (
					<Button appearance="default" onClick={onSecondaryAction}>
						{formatMessage(messages.retryButtonLabel)}
					</Button>
				)}
			</Inline>
		</Inline>
	);
};
